import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { getAuthToken } from '../utils/authStorage';

const UserContext = createContext(null);

export function UserProvider({ children }) {
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isViewer, setIsViewer] = useState(false);
    const [loading, setLoading] = useState(true);

    const loadUser = useCallback(async () => {
        const token = getAuthToken();
        if (!token) {
            setLoading(false);
            return;
        }
        try {
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            const decoded = jwtDecode(token);
            const adminRole = decoded.roles?.some(r => r.name === 'ROLE_ADMIN') ?? false;

            const res = await axios.get('/api/users/me');
            setUser({
                ...res.data,
                fullName: res.data?.fullName || res.data?.clientName || '',
            });
            setIsAdmin(adminRole || res.data?.admin === true);
            setIsViewer(res.data?.viewer === true || res.data?.roles?.includes('ROLE_VIEWER'));
        } catch (e) {
            console.error('Error loading user:', e);
        } finally {
            setLoading(false);
        }
    }, []);

    const clearUser = useCallback(() => {
        setUser(null);
        setIsAdmin(false);
        setIsViewer(false);
        delete axios.defaults.headers.common["Authorization"];
    }, []);

    useEffect(() => {
        loadUser();
    }, [loadUser]);

    return (
        <UserContext.Provider value={{ user, isAdmin, isViewer, loading, loadUser, clearUser }}>
            {children}
        </UserContext.Provider>
    );
}

export const useUser = () => useContext(UserContext);
